var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"btn-yzm",attrs:{"slot":"append","type":_vm.type,"disabled":_vm.btnDisabled,"loading":_vm.loadingController},on:{"click":_vm.getYzm},slot:"append"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }